export const WINDOW_LOCATION = 'windowLocation'
export const VUE_ROUTER = 'vueRouter'
